import * as React from "react"

import { Skeleton } from "@/components/ui/skeleton"
import { getArtworkUrl } from "@/lib/artwork"
import { getFallbackArt } from "@/lib/fallback-art"
import { cn } from "@/lib/utils"
import type { Song } from "@/types/song"

interface AlbumArtProps {
  song: Song
  className?: string
}

export function AlbumArt({ song, className }: AlbumArtProps) {
  const url = getArtworkUrl(song)
  const [errored, setErrored] = React.useState(false)
  const [loaded, setLoaded] = React.useState(false)
  const fallback = getFallbackArt(song.id, song.title)

  if (!url || errored) {
    return (
      <div
        className={cn(
          "flex aspect-square w-full items-center justify-center overflow-hidden",
          className
        )}
        style={{ backgroundColor: fallback.background }}
        role="img"
        aria-label={`${song.title} - ${song.artist} 앨범아트 없음`}
      >
        <span
          className="text-4xl font-semibold"
          style={{ color: fallback.foreground }}
        >
          {fallback.glyph}
        </span>
      </div>
    )
  }

  return (
    <div className={cn("relative aspect-square w-full overflow-hidden", className)}>
      {!loaded && <Skeleton className="absolute inset-0 rounded-none" />}
      <img
        src={url}
        alt={`${song.title} - ${song.artist} 앨범아트`}
        loading="lazy"
        referrerPolicy="no-referrer"
        className={cn(
          "size-full object-cover transition-opacity duration-300",
          loaded ? "opacity-100" : "opacity-0"
        )}
        onLoad={() => setLoaded(true)}
        onError={() => setErrored(true)}
      />
    </div>
  )
}
